import apiClient from '../../../utils/lib/apiClient';
import { loadingState, loadingText } from '../../../states/loadingState';
import { useSetRecoilState } from 'recoil';
export const useGetWorkersByKana = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getWorkers = async (kanaStr: string) => {
    setLoadingAnimation(true);
    setLoadingText('検索中...');
    try {
      // const res = await axios.get(
      //   `https://kintoneconnect-6ywpmfhxlq-an.a.run.app/api/users/worker-info/${searchId}`
      // );
      // const res = await apiClient.get(
      //   `https://kinoneconnect-okdftkfcxq-an.a.run.app/api/users/worker-info/${searchId}`
      // );
      const res = await apiClient.get(
        `/siteDiary/worker-info/workers-by-kana/${kanaStr}`
      );

      const data = res.data;
      if (data[0] !== '') return res.data;

      return null;
    } catch (e) {
      window.alert(`エラーが発生しました${e}`);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText('');
    }
  };

  return getWorkers;
};
